import type { ContentSection } from './types';

export const nextStepsContent: ContentSection = {
  id: 'next-steps',
  title: 'Next Steps 📞',
  content: 'Ready to build something innovative together?',
  subsections: [],
  customComponent: 'next-steps-cta'
};